<template>
  <Content title="">
    <template v-slot:title_row>
      <EditRadio/>
    </template>
    <template
      v-slot:search
    >
      <a-form
        layout="inline"
      >
        <a-row :gutter="32">
          <a-col :span="5">
            <a-form-item label="门店id">
              <a-input
                v-model="id"
                placeholder="请输入"
                autocomplete="off"
              />
            </a-form-item>
          </a-col>
          <a-col :span="5">
            <a-form-item label="门店名称">
              <a-input
                v-model="storeName"
                placeholder="请输入"
                autocomplete="off"
              />
            </a-form-item>
          </a-col>
          <a-col :span="5">
            <a-form-item label="所在省份">
              <a-select
                v-model="provinceId"
                placeholder="全部"
                @change="handleSelectChange('provinceId', $event)"
              >
                <a-select-option
                  v-for="item in provinceAll"
                  :value="item.id"
                  :key="item.id"
                >{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="5">
            <a-form-item label="所在城市">
              <a-select
                v-model="cityId"
                placeholder="全部"
                @change="handleSelectChange('cityId', $event)"
              >
                <a-select-option
                  v-for="item in chosedCityList"
                  :value="item.id"
                  :key="item.id"
                >{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row
          :gutter="32"
          style="margin-top: 12px"
        >
          <a-col :span="5">
            <a-form-item label="门店业态">
              <a-select
                v-model="formatId"
                placeholder="全部"
                @change="handleSelectChange('formatId', $event)"
              >
                <a-select-option
                  v-for="item in formatAll"
                  :value="item.id"
                  :key="item.id"
                >{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="5">
            <a-form-item label="异常状态">
              <a-select
                v-model="checkResult"
                placeholder="全部"
                @change="handleSelectChange('checkResult', $event)"
              >
                <a-select-option :value="'ok'">正常</a-select-option>
                <a-select-option :value="'fluctation'">异常</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <a-form-item>
              <a-button
                type="primary"
                html-type="submit"
                @click="handleSearch"
              >查询</a-button>
              <a-button
                html-type="reset"
                @click="handleSearchReset"
              >重置</a-button>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </template>
    <template
      v-slot:content
    >
      <a-table
        :columns="columns"
        :data-source="storeList.list"
        :row-key="record => record.id"
        :pagination="pagination"
      />
    </template>
  </Content>
</template>

<script>
import { mapState } from 'vuex';
import Content from '@/components/Content';
import EditRadio from './edit-radio';

const columns = [
  {
    title: '门店id',
    dataIndex: 'id',
  },
  {
    title: '门店名称',
    dataIndex: 'storeName',
  },
  {
    title: '所在省市',
    dataIndex: 'provinceName',
    customRender: (text, record) => `${record.provinceName}-${record.cityName}`,
  },
  {
    title: '门店业态',
    dataIndex: 'formatName',
  },
  {
    title: '异常状态',
    dataIndex: 'checkResult',
    customRender: (text) => {
      if (text === 'ok') {
        return '正常';
      }
      if (text === 'fluctation') {
        return '异常';
      }
      return '--';
    },
  },
];

export default {
  components: {
    Content, EditRadio,
  },
  data() {
    return {
      columns,
      currPage: 1,
      currFieldsValue: {},
      showEditModal: false,
      editingAccount: null,
      chosedCityList: [{ id: '', name: '全部' }],
      id: '',
      storeName: '',
      provinceId: undefined,
      cityId: undefined,
      formatId: undefined,
      checkResult: undefined,
      filedsList: ['id', 'storeName', 'provinceId', 'cityId', 'formatId', 'checkResult'],
    };
  },
  computed: {
    ...mapState('storeManage', ['storeList', 'provinceAll', 'formatAll']),
    pagination() {
      return {
        current: this.currPage,
        defaultPageSize: this.$consts.PAGE_SIZE,
        total: this.storeList.total,
        onChange: this.handlePagination,
      };
    },
  },
  methods: {
    async loadData(pageNum = 1) {
      if (this.id && !Number(this.id)) {
        this.$message.error('请输入正确的门店id查询');
        return;
      }
      this.currPage = pageNum;
      const keysExtValue = {};
      this.filedsList.forEach((item) => {
        if (this[item]) {
          keysExtValue[item] = this[item];
        }
      });
      this.$store.dispatch('storeManage/fetchManage', {
        pageNum,
        pageSize: this.$consts.PAGE_SIZE,
        ...keysExtValue,
      });
    },
    handlePagination(pageNum) {
      this.loadData(pageNum);
    },
    handleSearch() {
      this.$nextTick(() => {
        this.loadData();
      });
    },
    handleSearchReset() {
      this.filedsList.forEach((item) => {
        if (item === 'id' || item === 'storeName') {
          this[item] = '';
        } else {
          this[item] = undefined;
        }
      });
      this.chosedCityList = [{ id: '', name: '全部' }];
      this.handleSearch();
    },
    handleProvinceSelect(val) {
      this.chosedCityList = this.chosedCityList.concat(
        this.provinceAll.find(item => String(item.id) === String(val)).list,
      );
    },
    handleSelectChange(key, value) {
      this[key] = value;
      if (key === 'provinceId') {
        this.handleProvinceSelect(value);
      }
    },
  },
  created() {
    this.loadData();
  },
};
</script>
